import { useTranslation } from 'react-i18next';
import { Group, Select, useMantineTheme, Stack, TextInput, Divider, Title } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconSearch, IconFilter } from '@tabler/icons-react';
import { getFlagEmoji } from '@/utils/languageUtils';
import styles from './ContentTable.module.scss';

interface ContentTableControlsProps {
  contents: any[];
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  statusFilter: string;
  setStatusFilter: (value: string) => void;
  langFilter: string;
  setLangFilter: (value: string) => void;
  itemsPerPage: number;
  setItemsPerPage: (value: number) => void;
}

export const ContentTableControls = ({
  contents,
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  langFilter,
  setLangFilter,
}: ContentTableControlsProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const uniqueLangs = Array.from(new Set(contents.map(content => content.lang)));

  return (
    <Stack className={styles['contentTable__filters-wrapper']} gap="xs">
      <Title order={5}>{t('contentTable.title', 'Gestor de Contenidos')}</Title>

      <Group grow wrap={isMobile ? 'wrap' : 'nowrap'} gap="sm">
        <TextInput
          placeholder={t('contentTable.searchPlaceholder')}
          leftSection={<IconSearch size={16} />}
          value={searchTerm}
          onChange={e => setSearchTerm(e.currentTarget.value)}
          radius="md"
          size="sm"
          className={styles['contentTable__input']}
        />

        <Select
          placeholder={t('contentTable.statusFilter')}
          leftSection={<IconFilter size={16} />}
          value={statusFilter}
          onChange={value => setStatusFilter(value || 'all')}
          data={[
            { value: 'all', label: t('contentTable.allStatus') },
            { value: 'P', label: t('contentTable.published') },
            { value: 'U', label: t('contentTable.unpublished') },
            { value: 'D', label: t('contentTable.deleted') },
          ]}
          radius="md"
          size="sm"
          className={styles['contentTable__input']}
        />

        <Select
          placeholder={t('newContent.table.lang')}
          value={langFilter}
          onChange={value => setLangFilter(value || 'all')}
          data={[
            { value: 'all', label: t('common.all') },
            ...uniqueLangs.map(lang => ({
              value: lang,
              label: `${getFlagEmoji(lang)} ${lang.toUpperCase()}`,
            })),
          ]}
          radius="md"
          size="sm"
          className={styles['contentTable__input']}
        />
      </Group>

      <Divider my="xs" />
    </Stack>
  );
};
